import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const VipTableLowBalanceConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const currentPopupData = usePopupSlice.currentPopupData();
  let messageData: string[] = [];
  let isLowFreeChipBalance = false;

  if (currentPopupData !== null) {
    messageData = currentPopupData.messageData as string[];
    isLowFreeChipBalance = !!currentPopupData.isLowFreeChipBalance;
  }
  const shouldRedirectToLobby = Boolean(currentPopupData?.popUpInGame);

  useEffect(() => {
    if (shouldRedirectToLobby) {
      const timeoutId = setTimeout(() => {
        redirectToLobby();
      }, 3000); // existing functionality where user needs to be redirected to lobby after 3 sec showing popup

      return (): void => clearTimeout(timeoutId);
    }
  }, [shouldRedirectToLobby]);

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        if (shouldRedirectToLobby) {
          redirectToLobby();
        } else {
          dispatch(popupActions.dismissPopup(PopupType.VipTableLowBalance));
        }
      }}
    />,
  ];

  return (
    <BlockingModalContent title={<L10nText tk="LOWGAMEBALANCE" />} actions={action}>
      {isLowFreeChipBalance ? (
        <L10nText tk="POPUP_FREE_CHIPS_PRIVE_LOW_BALANCE" dynamicValues={messageData} />
      ) : (
        <L10nText tk="LOBBY_PRIVATE_TABLE_LOW_BALANCE" dynamicValues={messageData} />
      )}
    </BlockingModalContent>
  );
};
